import React from "react";

import Popover from "@material-ui/core/Popover";
import TextField from "@material-ui/core/TextField";

interface Props {
  name?: string;
  label?: string;
  value: any;
  required?: boolean;
  // onChange: (event: any) => void
  className?: string;
  inputProps?: any;
  itemToString: (value: any) => string;
  // closeDialogOnSelection?: boolean
  children: any;
}

function CustomSelectSimple(props: Props) {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  function handleOpen(
    event: React.MouseEvent<HTMLElement> | React.FocusEvent<HTMLElement>
  ) {
    setAnchorEl(event.currentTarget);
    // setAnchorEl(anchorEl ? null : event.currentTarget);
  }

  function handleClose() {
    setAnchorEl(null);
  }

  const open = Boolean(anchorEl);
  // const id = open ? 'custom-select-popup' : undefined;

  const { value, label, required, itemToString, inputProps } = props;
  return (
    <div className={props.className}>
      <TextField
        // id="custom-select-text-field"
        label={label}
        InputLabelProps={{
          // ...getLabelProps(),
          shrink: open || !!value, // TODO || !!fromDate || !!toDate
        }}
        // placeholder="From:"
        margin="none"
        fullWidth
        InputProps={{
          ...inputProps,
          readOnly: true,
          onClick: handleOpen,
          // onFocus: handleOpen
        }}
        value={itemToString(value)}
        required={required}
      />
      <Popover
        // id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          // horizontal: "center",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
        // PaperProps={{ style: { overflowX: "auto" } }}
        style={{
          maxWidth: "75vw",
          // maxHeight: '75vh'
        }}
      >
        {props.children}
      </Popover>
    </div>
  );
}

export default CustomSelectSimple;
